import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connect } from "./redux/blockchain/blockchainActions";
import { fetchData } from "./redux/data/dataActions";
import Preloader from "../src/components/Pre";
import Navbar from "./components/Navbar";
import Home from "./components/Home/Home";
import faq from "./components/FAQ/faq";
import roadmap from "./components/RoadMap/roadmap";
import NFTGallery from "./components/NFTGallery/NFTGallery";
import Footer from "./components/Footer";
import Copyright from "./components/Copyright";
import MintNFT from "./components/MintNFT/MintNFT";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./style.css";
import "./App.css";
import "./bootstrap.css";
// import "bootstrap/dist/css/bootstrap.min.css";


function App() {
  const [load, upadateLoad] = useState(false);
  // useEffect(() => {
  //   setTimeout(() => {
  //     upadateLoad(false);
  //   }, 1200);
  // }, []);

  return (
    <Router  class="Site">
      <Preloader load={load} />
      <div class="Site-content" className="App" id={load ? "no-scroll" : "scroll"}>
        <Navbar />
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/faq" component={faq} />
          <Route path="/roadmap" component={roadmap} />
          <Route path="/mintnft" component={MintNFT} />
          <Route path="/nftgallery" component={NFTGallery} />
          <Route path="/copyr" component={Copyright} />
        </Switch>
      </div>
    </Router>
  );
}

export default App;
